// import { notify } from "@general-backoffice/core";
import { notify } from "@general-backoffice/core/index";
import pick from "lodash/pick";

import { type User, usersEndpoints } from "../../../api";
import { useStrapiOne } from "../../../hooks/strapi";
import getErrorMessage from "../../../utils/getErrorMessage";
import handleError from "../../utils/handleError";

interface UseUserProps {
  params?: Record<string, unknown>;
  autoLoad?: boolean;
  [key: string]: unknown;
}

interface LoadUserParams {
  [key: string]: unknown;
}

const useUser = (id: number | string | undefined, props?: UseUserProps) => {
  const {
    item: user,
    setItem: setUser,
    load,
    isLoading,
    setLoading,
    ...other
  } = useStrapiOne<User>({
    id,
    ...props,
    loadItem: loadUser,
    submitItem: (v: User | null) => updateUser(id, v),
  });

  return {
    user,
    setUser,
    load,
    refresh: load,
    isLoading,
    setLoading,
    ...other,
  };
};

export const loadUser = async (id: number | string | undefined, params?: LoadUserParams) => {
  if (!id) return undefined;
  try {
    const { data } = await (id === "me" ? usersEndpoints.getMe(params) : usersEndpoints.getUser(Number(id), params));
    return data;
  } catch (err: unknown) {
    handleError(getErrorMessage(err, "Error al cargar el usuario"));
  }
};

// export const updateIsPartner = async (id, newState) => {
//   try {
//     return await usersEndpoints.updateIsPartner(id, newState)
//   } catch (e) {
//     handleError(e?.message || "Error al actualizar el usuario")
//   }
// }

export const updateUser = async (id: number | string | undefined, user: Partial<User> | null) => {
  const errMsg = "Error al actualizar el usuario";
  if (!id || !user) throw new Error(errMsg);
  try {
    const rawBody = pick(user, ["country", "mainCurrency", "partnerInfo"]);
    // Convert null to undefined for API compatibility
    const body: { country?: string; mainCurrency?: string; partnerInfo?: Record<string, unknown> } = {
      country: rawBody.country ?? undefined,
      mainCurrency: rawBody.mainCurrency ?? undefined,
      partnerInfo: rawBody.partnerInfo ?? undefined,
    };

    const { data } = await (id === "me" ? usersEndpoints.updateMe(body) : usersEndpoints.updateUser(Number(id), body));

    notify.success("Update finished correctly");
    return data;
  } catch (err: unknown) {
    handleError(getErrorMessage(err, errMsg));
  }
};

// export const updateUser = async user => {
//   const errMsg = `User update failed`
//   if (!user) throw new Error(errMsg)
//   try {
//
//     const { id, interests, country, ...props } = user
//
//     const body = {
//       ...(interests !== undefined && {interests: interests.map(i => i.id)}),
//       ...(country !== undefined && {country: country?.id}),
//       ...props
//     }
//
//     const res = await usersEndpoints.update(id, body)
//
//     notify.success(`User updated correctly`)
//     return res
//   } catch (e) {
//     handleError(e?.message || errMsg)
//   }
// }

export default useUser;
